import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className="footer">
        <p className="footer-info">&copy;  All rights reserved by <strong>BUGATTI CHIRON SUPER SPORT</strong> 2022 |
            <a target="_blank" rel="noreferrer noopener" href="https://github.com/Shaha-Alam"
                className="author"> Shaha-Alam </a>
        </p>
    </div>
    );
};

export default Footer;